// extracted by mini-css-extract-plugin
export default {"wrapper":"_1d-5Q43uGHWVkhQJecXPTo","value":"_1FyHxc3bqi74-ajYgdjHyY"};